var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoreNetworkPolicyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 11,
    height: 13,
    rx: 1.5,
    stroke: "#8C4FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#8C4FFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3.5,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "#8C4FFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#8C4FFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "#8C4FFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#8C4FFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11.5,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "#8C4FFF"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIyLjUiIHk9IjEuNSIgd2lkdGg9IjExIiBoZWlnaHQ9IjEzIiByeD0iMS41IiBzdHJva2U9IiM4QzRGRkYiLz4KICAgIDxyZWN0IHg9IjQiIHk9IjMiIHdpZHRoPSIyIiBoZWlnaHQ9IjIiIHJ4PSIwLjUiIGZpbGw9IiM4QzRGRkYiLz4KICAgIDxyZWN0IHg9IjciIHk9IjMuNSIgd2lkdGg9IjUiIGhlaWdodD0iMSIgcng9IjAuNSIgZmlsbD0iIzhDNEZGRiIvPgogICAgPHJlY3QgeD0iNCIgeT0iNyIgd2lkdGg9IjIiIGhlaWdodD0iMiIgcng9IjAuNSIgZmlsbD0iIzhDNEZGRiIvPgogICAgPHJlY3QgeD0iNyIgeT0iNy41IiB3aWR0aD0iNSIgaGVpZ2h0PSIxIiByeD0iMC41IiBmaWxsPSIjOEM0RkZGIi8+CiAgICA8cmVjdCB4PSI0IiB5PSIxMSIgd2lkdGg9IjIiIGhlaWdodD0iMiIgcng9IjAuNSIgZmlsbD0iIzhDNEZGRiIvPgogICAgPHJlY3QgeD0iNyIgeT0iMTEuNSIgd2lkdGg9IjUiIGhlaWdodD0iMSIgcng9IjAuNSIgZmlsbD0iIzhDNEZGRiIvPgo8L3N2Zz4K";
export { SvgCoreNetworkPolicyIcon as ReactComponent };